export default "__VITE_ASSET__XQ7PmBkK__"